import script from "./SearchResultsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultsList.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultsList.vue?vue&type=style&index=0&id=71537d21&lang=scss"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QIcon});qInstall(script, 'directives', {Ripple});
